import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
  Alert,
  Typography,
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const DeleteDialog = ({
  open,
  onClose,
  onConfirm,
  itemName,
  itemType,
  isDeleting,
  error,
  children,
  title = "Confirm Deletion",
  confirmLabel = "Delete",
  confirmColor = "error",
  overrideContent = null
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="delete-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
        <DeleteForeverIcon sx={{ mr: 1, color: `${confirmColor}.main` }} />
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          {overrideContent ? (
            overrideContent
          ) : (
            <>
              Are you sure you want to permanently delete the {itemType || 'item'}:
              <Typography component="strong" sx={{ fontWeight: 'bold', display: 'block', my: 1, color: 'text.primary' }}>
                {itemName || `this ${itemType}`}
              </Typography>
              This action cannot be undone.
            </>
          )}
          {children}
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isDeleting ? 'Processing...' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  itemName: PropTypes.string,
  itemType: PropTypes.string,
  isDeleting: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  confirmLabel: PropTypes.string,
  confirmColor: PropTypes.string,
  overrideContent: PropTypes.node,
};

export default DeleteDialog;